import React from "react";
import "./FloatingButtons.css";

export default function WhatsappButton() {
  return (
    <a
      href="https://wa.me/911234567890" // Replace with your WhatsApp number
      className="wa-floating-btn"
      target="_blank"
      rel="noopener noreferrer"
    >
      <img
        src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg"
        alt="WhatsApp"
      />
    </a>
  );
}
